<template>
  <div>
    <el-breadcrumb class="bread" separator-class="el-icon-arrow-right" activi>
      <el-breadcrumb-item>
        <span class="title">报表</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <span class="title">区间报表</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div class="tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane name="first">
          <span slot="label" class="tab_label">
            <span>蒸汽</span>
            <span class="iconfont" style="color:#C8E1FF;font-size:19px">&#xe617;</span>
          </span>
          <div class="conditon">
            <span class="screen">
              站点筛选
              <i class="el-icon-caret-bottom"></i>
            </span>
            <span class="screen" style="margin-right:10px">开始时间</span>
            <!-- 开始日期和时间 -->
            <div class="block">
              <!-- 开始日期 -->
              <el-date-picker
                v-model="startDate"
                :picker-options="pickerOptionsStart"
                @change="changeStart"
                value-format="timestamp"
                type="date"
                placeholder="开始日期"
                format="yyyy/MM/dd"
                style="width:140px;height:30px;margin-right:10px"
              ></el-date-picker>
              <!-- 开始时间 -->
              <el-time-picker
                style="width:120px;height:30px;"
                v-model="startTime"
                placeholder="开始时间"
                format="HH:mm"
                value-format="HH:mm"
                :picker-options="{selectableRange:`00:00:00-${endTime ? endTime+':00' : '23:59:59'}`}"
              ></el-time-picker>
            </div>
            <span class="screen" style="margin-left:23px;margin-right:10px">结束时间</span>
            <!-- 结束日期和时间 -->
            <div class="block">
              <!-- 结束日期 -->
              <el-date-picker
                v-model="endDate"
                format="yyyy/MM/dd "
                value-format="timestamp"
                :picker-options="pickerOptionsEnd"
                @change="changeEnd"
                type="date"
                placeholder="结束日期"
                style="width:140px;height:30px;margin-right:10px"
              ></el-date-picker>
              <!-- 结束时间 -->
              <el-time-picker
                style="width:120px;height:30px;"
                v-model="endTime"
                placeholder="结束时间"
                format="HH:mm"
                value-format="HH:mm"
                :picker-options="{selectableRange:`${startTime ? startTime + ':00' : '00:00:00'}-23:59:59`}"
              ></el-time-picker>
            </div>
            <span class="screen" style="margin-left:23px;margin-right:10px">选择预设时间</span>
            <el-select
              v-model="value"
              placeholder="请选择"
              style="width:140px;height:30px;margin-right:10px"
              @change="currentSel"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <div class="right" style="margin-left:320px">
              <el-button plain type="primary" class="button">
                <span>查询</span>
              </el-button>
              <el-button plain type="primary" class="button">
                <span>导出</span>
              </el-button>
              <el-button plain type="primary" class="button">
                <span>打印</span>
              </el-button>
            </div>
          </div>
           <ul class="chartList">
            <li>
              <div class="li_top">
                <span>三版1</span>
                <span>参考值：4.68T/h</span>
              </div>
              <div class="li_middle">
                <div style="margin-right:28px">
                  <el-input v-model="input1" placeholder></el-input>%—
                  <el-input v-model="input2" placeholder></el-input>%
                </div>
                <div style="margin-right:20px">
                  <el-input v-model="input3" placeholder></el-input>T/h—
                  <el-input v-model="input4" placeholder></el-input>T/h
                </div>
                <el-button type="primary" plain style="margin-top:10px;">查询</el-button>
              </div>
              <div
                class="myChart"
                id="bar_dv5"
                ref="chart5"
                :style="{width: '754px', height: '350px'}"
              ></div>
            </li>
             <li>
              <div class="li_top">
                <span>三版1</span>
                <span>参考值：4.68T/h</span>
              </div>
              <div class="li_middle">
                <div style="margin-right:28px">
                  <el-input v-model="input1" placeholder></el-input>%—
                  <el-input v-model="input2" placeholder></el-input>%
                </div>
                <div style="margin-right:20px">
                  <el-input v-model="input3" placeholder></el-input>T/h—
                  <el-input v-model="input4" placeholder></el-input>T/h
                </div>
                <el-button type="primary" plain style="margin-top:10px;">查询</el-button>
              </div>
              <div
                class="myChart"
                id="bar_dv6"
                ref="chart6"
                :style="{width: '754px', height: '350px'}"
              ></div>
            </li>
             <li>
              <div class="li_top">
                <span>三版1</span>
                <span>参考值：4.68T/h</span>
              </div>
              <div class="li_middle">
                <div style="margin-right:28px">
                  <el-input v-model="input1" placeholder></el-input>%—
                  <el-input v-model="input2" placeholder></el-input>%
                </div>
                <div style="margin-right:20px">
                  <el-input v-model="input3" placeholder></el-input>T/h—
                  <el-input v-model="input4" placeholder></el-input>T/h
                </div>
                <el-button type="primary" plain style="margin-top:10px;">查询</el-button>
              </div>
              <div
                class="myChart"
                id="bar_dv7"
                ref="chart7"
                :style="{width: '754px', height: '350px'}"
              ></div>
            </li>
             <li>
              <div class="li_top">
                <span>三版1</span>
                <span>参考值：4.68T/h</span>
              </div>
              <div class="li_middle">
                <div style="margin-right:28px">
                  <el-input v-model="input1" placeholder></el-input>%—
                  <el-input v-model="input2" placeholder></el-input>%
                </div>
                <div style="margin-right:20px">
                  <el-input v-model="input3" placeholder></el-input>T/h—
                  <el-input v-model="input4" placeholder></el-input>T/h
                </div>
                <el-button type="primary" plain style="margin-top:10px;">查询</el-button>
              </div>
              <div
                class="myChart"
                id="bar_dv8"
                ref="chart8"
                :style="{width: '754px', height: '350px'}"
              ></div>
            </li>
            </ul>
        </el-tab-pane>
        <el-tab-pane name="second">
          <span slot="label" class="tab_label">
            <span>电</span>
            <span class="iconfont" style="color:#FF5577;font-size:19px">&#xe655;</span>
          </span>
          <div class="conditon">
            <span class="screen">
              站点筛选
              <i class="el-icon-caret-bottom"></i>
            </span>
            <span class="screen" style="margin-right:10px">开始时间</span>
            <!-- 开始日期和时间 -->
            <div class="block">
              <!-- 开始日期 -->
              <el-date-picker
                v-model="startDate"
                :picker-options="pickerOptionsStart"
                @change="changeStart"
                value-format="timestamp"
                type="date"
                placeholder="开始日期"
                format="yyyy/MM/dd"
                style="width:140px;height:30px;margin-right:10px"
              ></el-date-picker>
              <!-- 开始时间 -->
              <el-time-picker
                style="width:120px;height:30px;"
                v-model="startTime"
                placeholder="开始时间"
                format="HH:mm"
                value-format="HH:mm"
                :picker-options="{selectableRange:`00:00:00-${endTime ? endTime+':00' : '23:59:59'}`}"
              ></el-time-picker>
            </div>
            <span class="screen" style="margin-left:23px;margin-right:10px">结束时间</span>
            <!-- 结束日期和时间 -->
            <div class="block">
              <!-- 结束日期 -->
              <el-date-picker
                v-model="endDate"
                format="yyyy/MM/dd "
                value-format="timestamp"
                :picker-options="pickerOptionsEnd"
                @change="changeEnd"
                type="date"
                placeholder="结束日期"
                style="width:140px;height:30px;margin-right:10px"
              ></el-date-picker>
              <!-- 结束时间 -->
              <el-time-picker
                style="width:120px;height:30px;"
                v-model="endTime"
                placeholder="结束时间"
                format="HH:mm"
                value-format="HH:mm"
                :picker-options="{selectableRange:`${startTime ? startTime + ':00' : '00:00:00'}-23:59:59`}"
              ></el-time-picker>
            </div>
            <span class="screen" style="margin-left:23px;margin-right:10px">选择预设时间</span>
            <el-select
              v-model="value"
              placeholder="请选择"
              style="width:140px;height:30px;margin-right:10px"
              @change="currentSel"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <div class="right" style="margin-left:320px">
              <el-button plain type="primary" class="button">
                <span>查询</span>
              </el-button>
              <el-button plain type="primary" class="button">
                <span>导出</span>
              </el-button>
              <el-button plain type="primary" class="button">
                <span>打印</span>
              </el-button>
            </div>
          </div>
          <ul class="chartList">
            <li>
              <div class="li_top">
             <span class="iconfont" style="color:#FF5577;font-size:19px">&#xe655;</span>
             <span>三版1</span>
             <span>参考值：4.68T/h</span>
              </div>
              <div class="li_middle">
                <div style="margin-right:28px">
                  <el-input v-model="input1" placeholder></el-input>%—
                  <el-input v-model="input2" placeholder></el-input>%
                </div>
                <div style="margin-right:20px">
                  <el-input v-model="input3" placeholder></el-input>T/h—
                  <el-input v-model="input4" placeholder></el-input>T/h
                </div>
                <el-button type="primary" plain style="margin-top:10px;">查询</el-button>
              </div>
              <div
                class="myChart"
                id="bar_dv"
                ref="chart1"
                :style="{width: '754px', height: '350px'}"
              ></div>
            </li>
            <li>
               <div class="li_top">
                <span>三版1</span>
                <span>参考值：4.68T/h</span>
              </div>
              <div class="li_middle">
                <div style="margin-right:28px">
                  <el-input v-model="input1" placeholder></el-input>%—
                  <el-input v-model="input2" placeholder></el-input>%
                </div>
                <div style="margin-right:20px">
                  <el-input v-model="input3" placeholder></el-input>T/h—
                  <el-input v-model="input4" placeholder></el-input>T/h
                </div>
                <el-button type="primary" plain style="margin-top:10px;">查询</el-button>
              </div>
              <div
                class="myChart"
                id="bar_dv2"
                ref="chart2"
                :style="{width: '754px', height: '350px'}"
              ></div>
            </li>
            <li>
               <div class="li_top">
                <span>三版1</span>
                <span>参考值：4.68T/h</span>
              </div>
              <div class="li_middle">
                <div style="margin-right:28px">
                  <el-input v-model="input1" placeholder></el-input>%—
                  <el-input v-model="input2" placeholder></el-input>%
                </div>
                <div style="margin-right:20px">
                  <el-input v-model="input3" placeholder></el-input>T/h—
                  <el-input v-model="input4" placeholder></el-input>T/h
                </div>
                <el-button type="primary" plain style="margin-top:10px;">查询</el-button>
              </div>
              <div
                class="myChart"
                id="bar_dv3"
                ref="chart3"
                :style="{width: '754px', height: '350px'}"
              ></div>
            </li>
            <li>
               <div class="li_top">
                <span>三版1</span>
                <span>参考值：4.68T/h</span>
              </div>
              <div class="li_middle">
                <div style="margin-right:28px">
                  <el-input v-model="input1" placeholder></el-input>%—
                  <el-input v-model="input2" placeholder></el-input>%
                </div>
                <div style="margin-right:20px">
                  <el-input v-model="input3" placeholder></el-input>T/h—
                  <el-input v-model="input4" placeholder></el-input>T/h
                </div>
                <el-button type="primary" plain style="margin-top:10px;">查询</el-button>
              </div>
              <div
                class="myChart"
                id="bar_dv4"
                ref="chart4"
                :style="{width: '754px', height: '350px'}"
              ></div>
            </li>
          </ul>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
const option = {
  tooltip: {
    trigger: "item",
    formatter: "{a} <br/>{b}: {c} ({d}%)",
  },
   graphic: [ {
  type: 'group',
          id: 'textGroup2',
          left: 370,
          top: 400,
          position :[10, 0],
          children: [
             
              {
                  type: 'text',
                  z: 100,
                  top: 'middle',
                  left: 100,
                  style: {
                      formatter: "{a} <br/>{b}: {c} ({d}%)",
                      text: [
                          '已安装1280个',
                          '未安装320个',
                      ].join('\n'),
                      font: '16px cursive',
                      textVerticalAlign :'middle',
                      fill:'#13a7d1',
                      
                      
                  }
              }
          ]
      }],
  grid: {
    containLabel: true,
  },
  legend: {
    // orient: 'vertical',
    icon: "circle",
    left: "center",
    top: 20,
    color: ["#4E84FF", "#FECC60"],
    data: ["时间占比", "用量占比"],
    textStyle: {
      //图例文字的样式
      color: "#5B5B5B",
      fontSize: 14,
    },
  },
  series: [
    {
      name: "访问来源",
      type: "pie",
      selectedMode: "single",
      radius: ["10%", "30%"],
      label: {
        position: "inner",
        show:true,
      },
      labelLine: {
        show: false,
      },
      data: [
        {
          value: 6.02,
          name: "用量占比",
          itemStyle: { color: "#FECC60", fontSize: 12 },
        },
      ],
    },
    {
      name: "访问来源",
      type: "pie",
      radius: ["40%", "55%"],
      label: {
        // position: "inner",
        show: true,
      },
      data: [
        {
          value: 1435,
          name: "时间占比",
          itemStyle: { color: "#4E84FF", fontSize: 12 },
        },
      ],
    },
  ],
};
const option2 = {
  tooltip: {
    trigger: "item",
    formatter: "{a} <br/>{b}: {c} ({d}%)",
  },
   graphic: [ {
  type: 'group',
          id: 'textGroup2',
          left: 370,
          top: 400,
          position :[10, 0],
          children: [
             
              {
                  type: 'text',
                  z: 100,
                  top: 'middle',
                  left: 100,
                  style: {
                      formatter: "{a} <br/>{b}: {c} ({d}%)",
                      text: [
                          '已安装1280个',
                          '未安装320个',
                      ].join('\n'),
                      font: '16px cursive',
                      textVerticalAlign :'middle',
                      fill:'#13a7d1',
                      
                      
                  }
              }
          ]
      }],
  grid: {
    containLabel: true,
  },
  legend: {
    // orient: 'vertical',
    icon: "circle",
    left: "center",
    top: 20,
    color: ["#4E84FF", "#FECC60"],
    data: ["时间占比", "用量占比"],
    textStyle: {
      //图例文字的样式
      color: "#5B5B5B",
      fontSize: 14,
    },
  },
  series: [
    {
      name: "访问来源",
      type: "pie",
      selectedMode: "single",
      radius: ["10%", "30%"],
      label: {
        position: "inner",
        show:true,
      },
      labelLine: {
        show: false,
      },
      data: [
        {
          value: 6.02,
          name: "用量占比",
          itemStyle: { color: "#FECC60", fontSize: 12 },
        },
      ],
    },
    {
      name: "访问来源",
      type: "pie",
      radius: ["40%", "55%"],
      label: {
        // position: "inner",
        show: true,
      },
      data: [
        {
          value: 1435,
          name: "时间占比",
          itemStyle: { color: "#4E84FF", fontSize: 12 },
        },
      ],
    },
  ],
};
const option3 = {
    tooltip: {
    trigger: "item",
    formatter: "{a} <br/>{b}: {c} ({d}%)",
  },
   graphic: [ {
  type: 'group',
          id: 'textGroup2',
          left: 370,
          top: 400,
          position :[10, 0],
          children: [
             
              {
                  type: 'text',
                  z: 100,
                  top: 'middle',
                  left: 100,
                  style: {
                      formatter: "{a} <br/>{b}: {c} ({d}%)",
                      text: [
                          '已安装1280个',
                          '未安装320个',
                      ].join('\n'),
                      font: '16px cursive',
                      textVerticalAlign :'middle',
                      fill:'#13a7d1',
                      
                      
                  }
              }
          ]
      }],
  grid: {
    containLabel: true,
  },
  legend: {
    // orient: 'vertical',
    icon: "circle",
    left: "center",
    top: 20,
    color: ["#4E84FF", "#FECC60"],
    data: ["时间占比", "用量占比"],
    textStyle: {
      //图例文字的样式
      color: "#5B5B5B",
      fontSize: 14,
    },
  },
  series: [
    {
      name: "访问来源",
      type: "pie",
      selectedMode: "single",
      radius: ["10%", "30%"],
      label: {
        position: "inner",
        show:true,
      },
      labelLine: {
        show: false,
      },
      data: [
        {
          value: 6.02,
          name: "用量占比",
          itemStyle: { color: "#FECC60", fontSize: 12 },
        },
      ],
    },
    {
      name: "访问来源",
      type: "pie",
      radius: ["40%", "55%"],
      label: {
        // position: "inner",
        show: true,
      },
      data: [
        {
          value: 1435,
          name: "时间占比",
          itemStyle: { color: "#4E84FF", fontSize: 12 },
        },
      ],
    },
  ],
}
const option4 = {
    tooltip: {
    trigger: "item",
    formatter: "{a} <br/>{b}: {c} ({d}%)",
  },
   graphic: [ {
  type: 'group',
          id: 'textGroup2',
          left: 370,
          top: 400,
          position :[10, 0],
          children: [
             
              {
                  type: 'text',
                  z: 100,
                  top: 'middle',
                  left: 100,
                  style: {
                      formatter: "{a} <br/>{b}: {c} ({d}%)",
                      text: [
                          '已安装1280个',
                          '未安装320个',
                      ].join('\n'),
                      font: '16px cursive',
                      textVerticalAlign :'middle',
                      fill:'#13a7d1',
                      
                      
                  }
              }
          ]
      }],
  grid: {
    containLabel: true,
  },
  legend: {
    // orient: 'vertical',
    icon: "circle",
    left: "center",
    top: 20,
    color: ["#4E84FF", "#FECC60"],
    data: ["时间占比", "用量占比"],
    textStyle: {
      //图例文字的样式
      color: "#5B5B5B",
      fontSize: 14,
    },
  },
  series: [
    {
      name: "访问来源",
      type: "pie",
      selectedMode: "single",
      radius: ["10%", "30%"],
      label: {
        position: "inner",
        show:true,
      },
      labelLine: {
        show: false,
      },
      data: [
        {
          value: 6.02,
          name: "用量占比",
          itemStyle: { color: "#FECC60", fontSize: 12 },
        },
      ],
    },
    {
      name: "访问来源",
      type: "pie",
      radius: ["40%", "55%"],
      label: {
        // position: "inner",
        show: true,
      },
      data: [
        {
          value: 1435,
          name: "时间占比",
          itemStyle: { color: "#4E84FF", fontSize: 12 },
        },
      ],
    },
  ],
}
const option5 = {
    tooltip: {
    trigger: "item",
    formatter: "{a} <br/>{b}: {c} ({d}%)",
  },
   graphic: [ {
  type: 'group',
          id: 'textGroup2',
          left: 370,
          top: 400,
          position :[10, 0],
          children: [
             
              {
                  type: 'text',
                  z: 100,
                  top: 'middle',
                  left: 100,
                  style: {
                      formatter: "{a} <br/>{b}: {c} ({d}%)",
                      text: [
                          '已安装1280个',
                          '未安装320个',
                      ].join('\n'),
                      font: '16px cursive',
                      textVerticalAlign :'middle',
                      fill:'#13a7d1',
                      
                      
                  }
              }
          ]
      }],
  grid: {
    containLabel: true,
  },
  legend: {
    // orient: 'vertical',
    icon: "circle",
    left: "center",
    top: 20,
    color: ["#4E84FF", "#FECC60"],
    data: ["时间占比", "用量占比"],
    textStyle: {
      //图例文字的样式
      color: "#5B5B5B",
      fontSize: 14,
    },
  },
  series: [
    {
      name: "访问来源",
      type: "pie",
      selectedMode: "single",
      radius: ["10%", "30%"],
      label: {
        position: "inner",
        show:true,
      },
      labelLine: {
        show: false,
      },
      data: [
        {
          value: 6.02,
          name: "用量占比",
          itemStyle: { color: "#FECC60", fontSize: 12 },
        },
      ],
    },
    {
      name: "访问来源",
      type: "pie",
      radius: ["40%", "55%"],
      label: {
        // position: "inner",
        show: true,
      },
      data: [
        {
          value: 1435,
          name: "时间占比",
          itemStyle: { color: "#4E84FF", fontSize: 12 },
        },
      ],
    },
  ],
}
const option6 = {
    tooltip: {
    trigger: "item",
    formatter: "{a} <br/>{b}: {c} ({d}%)",
  },
   graphic: [ {
  type: 'group',
          id: 'textGroup2',
          left: 370,
          top: 400,
          position :[10, 0],
          children: [
             
              {
                  type: 'text',
                  z: 100,
                  top: 'middle',
                  left: 100,
                  style: {
                      formatter: "{a} <br/>{b}: {c} ({d}%)",
                      text: [
                          '已安装1280个',
                          '未安装320个',
                      ].join('\n'),
                      font: '16px cursive',
                      textVerticalAlign :'middle',
                      fill:'#13a7d1',
                      
                      
                  }
              }
          ]
      }],
  grid: {
    containLabel: true,
  },
  legend: {
    // orient: 'vertical',
    icon: "circle",
    left: "center",
    top: 20,
    color: ["#4E84FF", "#FECC60"],
    data: ["时间占比", "用量占比"],
    textStyle: {
      //图例文字的样式
      color: "#5B5B5B",
      fontSize: 14,
    },
  },
  series: [
    {
      name: "访问来源",
      type: "pie",
      selectedMode: "single",
      radius: ["10%", "30%"],
      label: {
        position: "inner",
        show:true,
      },
      labelLine: {
        show: false,
      },
      data: [
        {
          value: 6.02,
          name: "用量占比",
          itemStyle: { color: "#FECC60", fontSize: 12 },
        },
      ],
    },
    {
      name: "访问来源",
      type: "pie",
      radius: ["40%", "55%"],
      label: {
        // position: "inner",
        show: true,
      },
      data: [
        {
          value: 1435,
          name: "时间占比",
          itemStyle: { color: "#4E84FF", fontSize: 12 },
        },
      ],
    },
  ],
}
const option7 = {
    tooltip: {
    trigger: "item",
    formatter: "{a} <br/>{b}: {c} ({d}%)",
  },
   graphic: [ {
  type: 'group',
          id: 'textGroup2',
          left: 370,
          top: 400,
          position :[10, 0],
          children: [
             
              {
                  type: 'text',
                  z: 100,
                  top: 'middle',
                  left: 100,
                  style: {
                      formatter: "{a} <br/>{b}: {c} ({d}%)",
                      text: [
                          '已安装1280个',
                          '未安装320个',
                      ].join('\n'),
                      font: '16px cursive',
                      textVerticalAlign :'middle',
                      fill:'#13a7d1',
                      
                      
                  }
              }
          ]
      }],
  grid: {
    containLabel: true,
  },
  legend: {
    // orient: 'vertical',
    icon: "circle",
    left: "center",
    top: 20,
    color: ["#4E84FF", "#FECC60"],
    data: ["时间占比", "用量占比"],
    textStyle: {
      //图例文字的样式
      color: "#5B5B5B",
      fontSize: 14,
    },
  },
  series: [
    {
      name: "访问来源",
      type: "pie",
      selectedMode: "single",
      radius: ["10%", "30%"],
      label: {
        position: "inner",
        show:true,
      },
      labelLine: {
        show: false,
      },
      data: [
        {
          value: 6.02,
          name: "用量占比",
          itemStyle: { color: "#FECC60", fontSize: 12 },
        },
      ],
    },
    {
      name: "访问来源",
      type: "pie",
      radius: ["40%", "55%"],
      label: {
        // position: "inner",
        show: true,
      },
      data: [
        {
          value: 1435,
          name: "时间占比",
          itemStyle: { color: "#4E84FF", fontSize: 12 },
        },
      ],
    },
  ],
}
const option8 = {
    tooltip: {
    trigger: "item",
    formatter: "{a} <br/>{b}: {c} ({d}%)",
  },
   graphic: [ {
  type: 'group',
          id: 'textGroup2',
          left: 370,
          top: 400,
          position :[10, 0],
          children: [
             
              {
                  type: 'text',
                  z: 100,
                  top: 'middle',
                  left: 100,
                  style: {
                      formatter: "{a} <br/>{b}: {c} ({d}%)",
                      text: [
                          '已安装1280个',
                          '未安装320个',
                      ].join('\n'),
                      font: '16px cursive',
                      textVerticalAlign :'middle',
                      fill:'#13a7d1',
                      
                      
                  }
              }
          ]
      }],
  grid: {
    containLabel: true,
  },
  legend: {
    // orient: 'vertical',
    icon: "circle",
    left: "center",
    top: 20,
    color: ["#4E84FF", "#FECC60"],
    data: ["时间占比", "用量占比"],
    textStyle: {
      //图例文字的样式
      color: "#5B5B5B",
      fontSize: 14,
    },
  },
  series: [
    {
      name: "访问来源",
      type: "pie",
      selectedMode: "single",
      radius: ["10%", "30%"],
      label: {
        position: "inner",
        show:true,
      },
      labelLine: {
        show: false,
      },
      data: [
        {
          value: 6.02,
          name: "用量占比",
          itemStyle: { color: "#FECC60", fontSize: 12 },
        },
      ],
    },
    {
      name: "访问来源",
      type: "pie",
      radius: ["40%", "55%"],
      label: {
        // position: "inner",
        show: true,
      },
      data: [
        {
          value: 1435,
          name: "时间占比",
          itemStyle: { color: "#4E84FF", fontSize: 12 },
        },
      ],
    },
  ],
}
 
export default {
  name: "intervalReport",
  data() {
    return {
      activeName: "second",
      startDate: "",
      startTime: "",
      endDate: "",
      endTime: "",
      pickerOptionsStart: {},
      pickerOptionsEnd: {},
      options: [
        {
          value: "item1",
          label: "自定义",
        },
        {
          value: "item2",
          label: "最近7天",
        },
        {
          value: "item3",
          label: "最近30天",
        },
        {
          value: "item4",
          label: "最近12月",
        },
        {
          value: "item5",
          label: "今天",
        },
        {
          value: "item6",
          label: "昨天",
        },
        {
          value: "item7",
          label: "本周",
        },
        {
          value: "item8",
          label: "上周",
        },
        {
          value: "item9",
          label: "本月",
        },
        {
          value: "item10",
          label: "上月",
        },
        {
          value: "item11",
          label: "今年",
        },
        {
          value: "item12",
          label: "去年",
        },
      ],
      value: "item1", //默认下拉菜单选中
      input1: "",
      input2: "",
      input3: "",
      input4: "",
    };
  },
  mounted() {
    this.$nextTick(() => {
      //   //echarts图表
      this.drawLine();
    });
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    beginDate() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.endDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.endDate).getTime() < time.getTime();
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },
    processDate() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.endDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return new Date(self.endDate).getTime() > time.getTime();
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },
    currentSel(selVal) {
      //获取下拉菜单选中的值
      console.log(selVal);
    },
    drawLine() {
      var echarts = require("echarts");
      var bar_dv  = this.$refs.chart1;
      var bar_dv2 = this.$refs.chart2;
      var bar_dv3 = this.$refs.chart3;
      var bar_dv4 = this.$refs.chart4;
      var bar_dv5 = this.$refs.chart5;
      var bar_dv6 = this.$refs.chart6;
      var bar_dv7 = this.$refs.chart7;
      var bar_dv8 = this.$refs.chart8;

      echarts.init(bar_dv).setOption(option, true);
      echarts.init(bar_dv2).setOption(option2, true);
      echarts.init(bar_dv3).setOption(option3, true);
      echarts.init(bar_dv4).setOption(option4, true);
      echarts.init(bar_dv5).setOption(option5, true);
      echarts.init(bar_dv6).setOption(option6, true);
      echarts.init(bar_dv7).setOption(option7, true);
      echarts.init(bar_dv8).setOption(option8, true);
    },
    changeStart() {
      // 限制开始时间
      //     disabledDate(date){
      //  //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
      // 	return date.getTime() > Date.now();
      // }
      this.pickerOptionsEnd = Object.assign({}, this.pickerOptionsEnd, {
        disabledDate: (time) => {
          if (this.startDate) {
            return time.getTime() < this.startDate;
          } else {
            // return time.getTime() > Date.now(); //开始时间不选时，结束时间最大值小于等于当天
          }
        },
      });
    },

    changeEnd() {
      // 限制结束时间
      // console.log(this.endDate);
      this.pickerOptionsStart = Object.assign({}, this.pickerOptionsStart, {
        disabledDate: (time) => {
          if (this.endDate) {
            return time.getTime() > this.endDate;
          } else {
            // return time.getTime() > Date.now(); //开始时间不选时，结束时间最大值小于等于当天
          }
        },
      });
    },

    beautifyTimeFormat(value) {
      // 时间戳转换时间格式
      if (value == null) {
        return "";
      } else {
        let date = new Date(value);
        let y = date.getFullYear(); // 年
        let MM = date.getMonth() + 1; // 月
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate(); // 日
        d = d < 10 ? "0" + d : d;
        return y + "-" + MM + "-" + d;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 14px;
  font-family: YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.bread {
  background: white;
  height: 50px;
  line-height: 50px;
  padding-left: 34px;
  margin-bottom: 10px;
}

.tabs {
  margin-top: 10px;
  ::v-deep .el-tabs__header {
    padding-left: 34px;
    padding-right: 34px;
    background: white;
    height: 50px;
    line-height: 51px;
  }
  .tab_label {
    display: inline-block;
    min-width: 100px;
    text-align: center;
    font-size: 18px;
    font-family: YaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
  }
  .el-tabs__item {
    border-right: 1px rgba(153, 153, 153, 1) solid !important;
  }
}
.conditon {
  display: flex;
  background: white;
  padding-top: 18px;
  padding-left: 34px;
  font-size: 14px;
  font-family: YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.screen {
  color: #333;
  font-size: 14px;
  margin: 11px 25px 20px 0px;
  display: inline-block;
}
.button {
  // width: 32px;
  height: 40px;
  margin-right: 10px;
  span {
    font-size: 16px;
    font-family: YaHei;
    font-weight: 400;
    // color: rgba(78, 132, 255, 1);
  }
}
::v-deep.el-input--suffix .el-input__inner {
  text-align: center;
}
.chartList {
  display: flex;
  flex-wrap: wrap;
  padding: 12px 37px 17px 38px;
  justify-content: space-between;
  li {
    width: 754px;
    height: 420px;
    border-radius: 10px;
    padding: 10px;
    box-sizing: border-box;
    background: white;
    .li_top {
      display: flex;
      justify-content: space-between;
      margin-bottom: 26px;
      font-size: 14px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: rgba(91, 91, 91, 1);
    }
    .li_middle {
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0px 65px;
      ::v-deep .el-input {
        width: 90px;
        height: 30px;
      }
    }
  }
}
</style>